import { FC, memo } from "react";
import { Flex, Text } from "@smile2impress/components/relaunch";
import { UTSLocale } from "@smile2impress/attraction-constants";
import { ClinicWithCityTitleProps } from "api/location";
import { useUTSLocaleContext } from "context/utsLocaleContext";

import { UrlsConfig } from "configs/urlsConfig";
import Link from "components/Link";

interface ClinicGridItemProps {
    clinic: ClinicWithCityTitleProps;
}

const ADDRESS_SPLIT_LOCALES = [UTSLocale.FRANCE_FR];
const DISCLAIMER_SPLIT_LOCALES = [UTSLocale.PORTUGAL_PT];

export const ClinicGridItem: FC<ClinicGridItemProps> = memo(({ clinic }) => {
    const { locale } = useUTSLocaleContext();
    const cityTitle = clinic.cityTitle || "";
    const clinicTitle = clinic.title || "";
    const [rawClinicAddress, extraClinicAddress = ""] =
        clinic.address?.split(";") || [];
    const clinicAddress = ADDRESS_SPLIT_LOCALES.includes(locale)
        ? extraClinicAddress?.trim()
        : rawClinicAddress;
    const [clinicNameBold, ...clinicNameRest] = clinicTitle?.split(",");
    const clinicId = clinic.id;
    const href =
        clinic?.isFlagship && clinic?.url
            ? `${clinic?.url}?clinicId=${clinicId}`
            : `${UrlsConfig.UNIVERSAL_FORM}?location=${cityTitle}&clinicId=${clinicId}`;
    const showPTClinicsDisclaimer =
        DISCLAIMER_SPLIT_LOCALES.includes(locale) && extraClinicAddress;

    return (
        <Flex
            key={`${clinicTitle}-${clinic.id}`}
            direction="column"
            alignItems="flex-start"
        >
            <Link
                href={href}
                textStyle="body"
                w="fit-content"
                color="text.base"
                mb="8px"
            >
                {cityTitle}
            </Link>
            <Link
                href={href}
                textStyle="bodySmall"
                w="fit-content"
                color="text.base"
            >
                <b>{clinicNameBold}</b>
                {clinicNameRest?.length > 0 && ","} {clinicNameRest}
                <br />
                {clinicAddress}
                {showPTClinicsDisclaimer && (
                    <Text
                        textStyle="captionSmall"
                        color="base.halfBlack"
                        mt={"8px"}
                    >
                        {extraClinicAddress}
                    </Text>
                )}
            </Link>
        </Flex>
    );
});
